import ResumeItem from "@/common/components/ResumeItem";
import { establishmentChoiceEntryOptions } from "../../../../constants/directiveEntryFormSteps/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant";
import CreateForwardingDirectiveEntryFormStepHeader from "../../../CreateForwardingDirectiveEntryFormStepHeader";
import { useFormContext, useWatch } from "react-hook-form";
import { EstablishmentChoiceEntryAuctionEntrySchema } from "../../../../schemas/entries/establishmentChoiceEntry.schema";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "../../../../types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

const EstablishmentChoiceEntryAuctionEntryCompleted = () => {
  const {
    control,
  } = useFormContext<EstablishmentChoiceEntryAuctionEntrySchema>();

  const {
    establishment_choice_entry_attributes: watchEstablishmentChoiceEntryAttributes,
  } = useWatch({
    control,
  });

  const auctionEntryOption = establishmentChoiceEntryOptions[MaintenanceForwardingEstablishmentChoiceEntryKlass.AuctionEntry];

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        title={auctionEntryOption.title}
        description={auctionEntryOption.description}
      />

      <div className="flex flex-col gap-2">
        <div className="flex gap-4">
          <ResumeItem
            label="Mínimo de propostas para arremtate"
            value={(watchEstablishmentChoiceEntryAttributes?.minimum_of_proposals_to_finish) || '--'}
            className="text-sm"
          />

          <ResumeItem
            label="Raio de exibição do leilão"
            value={(watchEstablishmentChoiceEntryAttributes?.allowance_radius_in_kilometers) || '--'}
            className="text-sm"
          />

          <ResumeItem
            label="Data de encerramento"
            value={(watchEstablishmentChoiceEntryAttributes?.finishes_at_date) || '--'}
            className="text-sm"
          />

          <ResumeItem
            label="Horário de encerramento"
            value={(watchEstablishmentChoiceEntryAttributes?.finishes_at_time) || '--'}
            className="text-sm"
          />
        </div>
      </div>
    </div>
  )
}

export default EstablishmentChoiceEntryAuctionEntryCompleted;
